import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import { CachePolicies } from "use-http";

interface GetImageQueriesArgs {
  url: string | null;
}

export const getImageQueries = createAsyncThunk("imageQueries/getImageQueries", async (args: GetImageQueriesArgs) => {
  if (args.url !== null) {
    const response = await fetch(args?.url, {
      cache: CachePolicies.NO_CACHE,
    });
    if (response.ok) {
      const data = await response.json();
      if (data?.results?.length === 0) {
        enqueueSnackbar("No results were found for these filters.", {
          variant: "info",
        });
      }
      return data;
    }
  }
  throw new Error("Failed to fetch api tokens");
});
